import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaTools, FaUserTie } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";

const StaffMaintenancePortal = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const roleName = user?.role === "regular_manager" ? "Regular Manager" : "Regular Official";

  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-100">
      <header className="border-b border-slate-200 bg-white shadow-sm">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-4">
          <div className="flex items-center gap-3"><div className="rounded-xl bg-slate-800 p-3 text-white"><FaUserTie /></div><div><h1 className="font-bold text-slate-900">{roleName} Portal</h1><p className="text-xs text-slate-500">{user?.name}</p></div></div>
          <button type="button" onClick={signOut} className="inline-flex items-center gap-2 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700"><FaSignOutAlt /> Logout</button>
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-3xl flex-1 items-center justify-center p-6">
        <div className="w-full rounded-2xl border border-amber-200 bg-white p-10 text-center shadow-sm">
          <FaTools className="mx-auto mb-4 text-5xl text-amber-500" />
          <h2 className="text-2xl font-black text-slate-900">Portal Under Maintenance</h2>
          <p className="mt-2 text-sm text-slate-600">Your regular {roleName.toLowerCase()} login is active. Portal features will be added here.</p>
        </div>
      </main>
      <footer className="border-t border-slate-200 bg-white py-4 text-center text-xs text-slate-500">Para Sports Association of Andhra Pradesh</footer>
    </div>
  );
};

export default StaffMaintenancePortal;
